'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.sitefeatures = void 0;
var tslib_1 = require("tslib");
var adapter_1 = require("../adapter");
var SiteFeatures = /** @class */ (function () {
    function SiteFeatures() {
    }
    /**
     * Gets the list of site features
     */
    SiteFeatures.prototype.fetch = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, adapter_1.adapter.sitefeatures.fetch()];
                    case 1:
                        res = _a.sent();
                        // Normalize optional values so they exist in their default form.
                        return [2 /*return*/, res.map(function (feature) {
                                var _a, _b;
                                return (tslib_1.__assign(tslib_1.__assign({}, feature), { roles: feature.roles || [], birthday: feature.birthday || false, onSiteMarketing: (_a = feature.onSiteMarketing) !== null && _a !== void 0 ? _a : true, noOnSiteMarketing: (_b = feature.noOnSiteMarketing) !== null && _b !== void 0 ? _b : true, affiliatesExcludes: feature.affiliatesExcludes || [], countriesExcludes: feature.countriesExcludes || [], rolesExcludes: feature.rolesExcludes || [], locationExcludes: feature.locationExcludes || [], platform: feature.platform || { mobile: true, desktop: true }, depositCount: feature.depositCount || null }));
                            })];
                }
            });
        });
    };
    return SiteFeatures;
}());
exports.sitefeatures = new SiteFeatures();
